/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-components/blob/master/LICENSE.md for details.
 * v1.0.7
 */
import { T as Tooltip, d as defineCustomElement$1 } from './tooltip.js';

const CalciteTooltip = Tooltip;
const defineCustomElement = defineCustomElement$1;

export { CalciteTooltip, defineCustomElement };
